import React, { useState } from "react";
import "./TitlePicker.scss";
interface TitlePickerProps {
  label: string;
  titles: any[];
  setTitles: React.Dispatch<React.SetStateAction<string>>;
}
const TitlePicker: React.FC<TitlePickerProps> = ({
  label,
  titles,
  setTitles,
}) => {
  const [selectedTitle, setSelectedTitle] = useState<string>(titles[0] || "");
  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedTitle(value);
    setTitles(value);
  };
  return (
    <div className='wr-input'>
      <div className='wr-input-lable'>{label}</div>
      <div className='wr-input-wrapper'>
        <select
          value={selectedTitle}
          onChange={handleSelectChange}
          className='wr-input-cont'
        >
          {titles.map((title) => (
            <option key={title} value={title}>
              {title}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
export default TitlePicker;
